import React from "react";
import { Header } from "../../components/layout/Header";
import { Card } from "../../components/common/Card";
import { MessageCircle } from "lucide-react";

export default function ChatPage() {
  return (
    <>
      <Header title='Chat' />
      <div className='px-4 py-4'>
        <Card>
          <div className='flex items-center gap-3 py-4'>
            <div className='w-10 h-10 rounded-xl bg-pink-50 flex items-center justify-center'>
              <MessageCircle size={22} className='text-pink-500' />
            </div>
            <div>
              <p className='font-bold text-primary-800'>Chat</p>
              <p className='text-xs text-gray-400'>
                Game and group chats coming soon
              </p>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
